import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/logo.png/'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "nav-right" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "account" }
const _hoisted_5 = ["src"]

import { computed, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useUserInfoStore } from "@/stores/userInfo";
import { useOAuthStore } from "@/stores/oauth";
import { ElMessageBox, ElMessage } from "element-plus";
import { useUIStore } from "@/stores/loginDialog";
import axiosInstance from "@/utils/axiosInstance";


export default /*@__PURE__*/_defineComponent({
  __name: 'main-header',
  setup(__props) {

const router = useRouter();
const userStore = useUserInfoStore();
const oauthStore = useOAuthStore();
const uiStore = useUIStore();

const userLogin = () => {
  if (!oauthStore.token) {
    uiStore.showLoginDialog();
  }
};

const creatorCenterUrl = computed(() => {
  const randomNumber = Math.floor(Math.random() * 90000000); // 生成一个随机数
  return `/creator/home?t=${randomNumber}`;
});

const getUserInfo = reactive({
  username: "",
  token: "",
});

onMounted(async () => {
  getUserInfo.username = computed(() => userStore.user?.uname ?? "");
  getUserInfo.token = oauthStore.token;
  fetchUserInfoTokenExpire();
});

// 退出登录
const logout = () => {
  ElMessageBox.confirm(
    "确定登出吗？程序员正在改变世界，我们需要你和我们在一起！",
    "温馨提示",
    {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }
  )
    .then(async () => {
      //清除 userinfo token
      oauthStore.clearToken();
      userStore.clearUser();
      localStorage.clear();
      router.push("/").then(() => {
        location.reload();
      });
      ElMessage.success("退出登录成功！");
    })
    .catch(() => {
      //错误捕获
    });
};

// 获取用户信息
const fetchUserInfoTokenExpire = async () => {
  try {
    const randontime = Math.floor(Math.random() * 90000000);
    await axiosInstance
      .get("/api/UserLogin/IsTokenExpire", {
        params: { refreshtime: randontime },
      })
      .then((res) => {
        var result = res.data;
        if (result.success) {
          if (result.data.IsTokenExpire == 1) {
            //清除 userinfo token
            oauthStore.clearToken();
            userStore.clearUser();
            localStorage.clear();
          }
        }
      });
  } catch (error) {
    ElMessage.error("获取信息失败");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "nav-left" }, [
        _createElementVNode("a", { href: "/" }, [
          _createElementVNode("img", {
            src: _imports_0,
            height: "37",
            width: "152"
          })
        ]),
        _createElementVNode("a", {
          href: "/",
          class: "active"
        }, " 首页 ")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        (getUserInfo.token)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "creatorbtn btn-primary",
              href: creatorCenterUrl.value,
              target: "_blank"
            }, "创作者中心", 8, _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          (getUserInfo.token)
            ? (_openBlock(), _createBlock(_component_el_row, {
                key: 0,
                class: "block-col-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown, { trigger: "click" }, {
                        dropdown: _withCtx(() => [
                          _createVNode(_component_el_dropdown_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_dropdown_item, { icon: "Setting" }, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                  _createElementVNode("a", {
                                    href: "/user/settings/profile",
                                    target: "_blank"
                                  }, "我的设置", -1)
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_dropdown_item, {
                                icon: "TurnOff",
                                onClick: logout
                              }, {
                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                  _createTextVNode("退出登录")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            class: "avatar",
                            src: _unref(userStore).user?.avatar_url || require('@/assets/user/defaultavatar.png')
                          }, null, 8, _hoisted_5)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (userLogin()))
              }, "登录"))
        ])
      ])
    ]),
    _createVNode(_component_el_divider)
  ], 64))
}
}

})